import { render, staticRenderFns } from "./noticeDetail1.vue?vue&type=template&id=8f86d1f4&scoped=true&"
import script from "./noticeDetail1.vue?vue&type=script&lang=js&"
export * from "./noticeDetail1.vue?vue&type=script&lang=js&"
import style0 from "./noticeDetail1.vue?vue&type=style&index=0&id=8f86d1f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f86d1f4",
  null
  
)

export default component.exports